const DEFAULT_TTL_MS = 5 * 60 * 1000;

interface CacheEntry<T> {
  expiresAt: number;
  promise: Promise<T>;
}

const cache = new Map<string, CacheEntry<any>>();

export function cachedRequest<T>(
  key: string,
  fetcher: () => Promise<T>,
  ttlMs: number = DEFAULT_TTL_MS
): Promise<T> {
  const now = Date.now();
  const existing = cache.get(key);
  if (existing && existing.expiresAt > now) {
    return existing.promise as Promise<T>;
  }

  const promise = fetcher().catch((err) => {
    cache.delete(key);
    throw err;
  });

  cache.set(key, { expiresAt: now + ttlMs, promise });
  return promise;
}

export function invalidateCachedRequest(keyOrPrefix: string): void {
  for (const key of Array.from(cache.keys())) {
    if (key === keyOrPrefix || key.startsWith(keyOrPrefix)) {
      cache.delete(key);
    }
  }
}

export function clearRequestCache(): void {
  cache.clear();
}
